import { render, staticRenderFns } from "./NewForm.vue?vue&type=template&id=24570ac4&scoped=true&"
import script from "./NewForm.vue?vue&type=script&lang=js&"
export * from "./NewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24570ac4",
  null
  
)

export default component.exports